const user_scopes = {
    descriptions: {
        custom_data: 'Your custom data',
        email: 'Your email address',
        phone: 'Your phone number',
        profile: 'Your name, username, avatar, and other profile info',
        roles: 'Your roles',
        identities: 'Your linked social identities',
        'urn:logto:scope:organizations': 'Your organizations info',
        'urn:logto:scope:organization_roles': 'Your organization roles',
        address: 'Your address',
        'urn:logto:scope:sessions': 'Your active sessions',
        'urn:logto:scope:trusted_devices': 'Your trusted devices',
        offline_access: 'Keep you signed in',
        'urn:logto:scope:personal_access_tokens': 'Your personal access tokens',
    },
};
export default Object.freeze(user_scopes);
